import React, {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";
import { URL_DEFAULT } from "../axios";
import axios from "axios";

// Создаем контекст
const AppContext = createContext();

// Создаем провайдер контекста
export const AppProvider = ({ children }) => {
    const [modalShow, setModalShow] = useState(false);
    const [formTheme, setFormTheme] = useState("");
    const [isAuthenticated, setIsAuthenticated] =
        useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await axios.post(
                    URL_DEFAULT + "index.php",
                    { type: "checkSession" }
                );
                if (response.data.user) {
                    setIsAuthenticated(true);
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };

        checkSession();
    }, []);

    return (
        <AppContext.Provider
        value={{
            formTheme,
            setFormTheme,
            modalShow,
            setModalShow,
            isAuthenticated,
            setIsAuthenticated,
        }}
        >
            {children}
        </AppContext.Provider>
    );
};

// Создаем хук для использования контекста
export const useAppContext = () => {
    return useContext(AppContext);
};
